import * as Sentry from '@sentry/browser';
import { SentryLogger } from '../../../sentryLogging/SentryLogger';
import { logConstants } from '../../../utils/Constants';
import { HttpHeaders, HttpRequest, HttpResponse } from '../../../utils/http/Http';
import { HttpStatusCodes } from '../../../utils/http/HttpConstants';
import { NativeBridgeFactory } from '../../bridge/nativeBridgeFactory';
import { CLOUD_HEADER_NAME, INDEX_URL, ROAMING_ACCOUNTS_SUFFIX } from '../../Constants';
import { AccountConfigErrorStrings } from '../../Errors';
import { Logger } from '../../utils/Logger';
import urlUtils from '../../utils/urlUtils';
import { HttpErrorCodes } from '../../../utils/http/HttpErrors';
import { Platform } from '../../../auth/AuthConstants';
import { config } from '../../../auth/AuthConfig';

export default class RoamingAccountsHelper {
	private nativeBridge = NativeBridgeFactory.getBridge();

	public getRoamingAccounts = async (urlStr: string): Promise<HttpResponse> => {
		try {
			const url = new URL(
				urlUtils.addPathToUrl(new URL(urlStr).origin, ROAMING_ACCOUNTS_SUFFIX)
			);
			const request = new HttpRequest(
				'GET',
				url,
				new HttpHeaders({
					Connection: 'Keep-Alive',
					Host: url.hostname,
				}),
				''
			);
			return new HttpResponse(await this.nativeBridge.fetch(request));
		} catch (e) {
			let errorType = AccountConfigErrorStrings.ROAMING_ACCOUNTS_FETCH_FAILURE;
			if (
				e.errorCode !== undefined &&
				(
					e.errorCode === HttpErrorCodes.ERROR_HTTP_SEND_FAILURE ||
					(
						config.platform === Platform.WINDOWS &&
						e.errorCode !== HttpErrorCodes.ERROR_WINHTTP_TIMEOUT &&
						e.errorCode !== HttpErrorCodes.ERROR_WINHTTP_NAME_NOT_RESOLVED
					)
				)
			) {
				errorType = AccountConfigErrorStrings.ROAMING_ACCOUNTS_SEND_FAILURE;
			}

			SentryLogger.getInstance().addBreadCrumb({
				type: 'error',
				category: 'accountConfig',
				message: `Failed to get roaming accounts due to error: ${errorType} : ${e.message}`,
				level: Sentry.Severity.Error,
			});

			Logger.getInstance().write(logConstants.ERROR, `${errorType} : ${e.message}`);
			throw new Error(errorType);
		}
	};

	public isCloudAccount = (roamingAccountsResponse: HttpResponse): boolean => {
		return (
			roamingAccountsResponse != undefined &&
			roamingAccountsResponse.statusCode === HttpStatusCodes.HTTP_STATUS_OK &&
			roamingAccountsResponse.headers.get(CLOUD_HEADER_NAME) != undefined
		);
	};

	public checkForHTTPRedirectURL = (
		roamingAccountsResponse: HttpResponse
	): string | null => {
		const statusCode = roamingAccountsResponse?.statusCode;
		const Location = roamingAccountsResponse?.headers.get('Location');
		return (statusCode === HttpStatusCodes.HTTP_STATUS_MOVED ||
			statusCode === HttpStatusCodes.HTTP_STATUS_REDIRECT) &&
			Location != undefined &&
			!Location.endsWith(INDEX_URL)
			? Location
			: null;
	};
}
